// extracted by mini-css-extract-plugin
module.exports = {"Title":"PageHeader_Title__3M7M2","Helper":"PageHeader_Helper__2xN8w","Subtitle":"PageHeader_Subtitle__2CmpW"};